import React from "react";

const ContactMe = () => {
  return (
    <section
      id="contact"
      className="layout-container py-24 md:py-32 border-t border-borderSubtle scroll-fade"
    >
      {/* Section Header */}
      <div className="flex flex-col">
        <span className="text-xs font-mono tracking-widest text-accent uppercase font-medium">
          <p>/ 05 / CONTACT</p>
        </span>
        <h1 className="text-3xl md:text-4xl font-normal text-white mt-2 tracking-tight">
          Let's build something.
        </h1>
      </div>

      {/* Description / Subtext */}
      <p className="text-zinc-400 text-base md:text-lg leading-relaxed mt-4 max-w-lg font-normal">
        Full-time inquiries & freelance are welcome
      </p>

      {/* Horizontal Links List */}
      <div className="flex flex-wrap items-center gap-x-8 gap-y-4 mt-8">
        {/* Email Link */}
        <a
          href="mailto:boralrupak@gmail.com"
          className="flex items-center gap-2.5 text-zinc-400 hover:text-white group transition-colors duration-300 font-normal text-sm md:text-base select-none"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="text-accent"
          >
            <rect width="20" height="16" x="2" y="4" rx="2" />
            <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
          </svg>
          <span className="border-b border-transparent group-hover:border-white/40 pb-0.5 transition-all">
            Email
          </span>
        </a>

        {/* GitHub Link */}
        <a
          href="https://github.com/RupakBoral"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2.5 text-zinc-400 hover:text-white group transition-colors duration-300 font-normal text-sm md:text-base select-none"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="text-accent"
          >
            <path d="M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4" />
            <path d="M9 18c-4.51 2-5-2-7-2" />
          </svg>
          <span className="border-b border-transparent group-hover:border-white/40 pb-0.5 transition-all">
            GitHub
          </span>
        </a>

        {/* LinkedIn Link */}
        <a
          href="https://www.linkedin.com/in/rupak-boral-169435249/"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2.5 text-zinc-400 hover:text-white group transition-colors duration-300 font-normal text-sm md:text-base select-none"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="text-accent"
          >
            <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
            <rect width="4" height="12" x="2" y="9" />
            <circle cx="4" cy="4" r="2" />
          </svg>
          <span className="border-b border-transparent group-hover:border-white/40 pb-0.5 transition-all">
            LinkedIn
          </span>
        </a>
      </div>
    </section>
  );
};

export default ContactMe;
